import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import {
  BankingDetails,
  BusinessProfile,
  BusinessDetailsRequest,
  BankingDetailsRequest,
} from '../../_interfaces/business.interface';
import { HttpClient } from '@angular/common/http';
import { DirectorApprovalDetail } from '../../_interfaces/director-approval.interface';

@Injectable({ providedIn: 'root' })
export class BusinessApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_BIZ = 'biz';
  URL_BANKING_DETAILS: string = 'bank-details';
  URL_APPROVAL_INFO: string = 'approval/info';
  URL_APPROVAL_APPROVE: string = 'approval/approve';
  URL_APPROVAL_DECLINE: string = 'approval/decline';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Get business details
   *
   * @return Observable<BusinessProfile>
   */
  getBusinessProfile(): Observable<BusinessProfile> {
    return this.http.get<BusinessProfile>(this.getUrl(this.URL_BIZ, true));
  }

  /**
   * Update business details
   *
   * @param bizId
   * @param data
   * @return Observable<BusinessDetailsRequest>
   */
  updateBusinessDetails(bizId: string, data: BusinessDetailsRequest): Observable<BusinessDetailsRequest> {
    const url = this.getUrl([this.URL_BIZ, bizId], true);
    return this.http.patch<BusinessDetailsRequest>(url, data);
  }

  /**
   * Get banking details
   *
   * @return Observable<BankingDetails>
   */
  getBankingDetails(): Observable<BankingDetails> {
    return this.http.get<BankingDetails>(this.getUrl([this.URL_BIZ, this.URL_BANKING_DETAILS], true));
  }

  /**
   * Create banking details
   *
   * @return Observable<BankingDetails>
   * @param data
   */
  createBankingDetails(data: BankingDetailsRequest): Observable<BankingDetails> {
    const url = this.getUrl([this.URL_BIZ, this.URL_BANKING_DETAILS], true);
    return this.http.post<BankingDetails>(url, data);
  }

  /**
   * Get approval info for constructing the checkbox label.
   * @return Observable<DirectorApprovalDetail>
   * @param token
   */
  approvalInfo(token: string): Observable<DirectorApprovalDetail> {
    return this.http.post<DirectorApprovalDetail>(this.getUrl(this.URL_APPROVAL_INFO, true), { token });
  }

  /**
   * Send approve response for updating banking details
   * @param token
   */
  approveBankingDetails(token: string) {
    return this.http.post(this.getUrl(this.URL_APPROVAL_APPROVE, true), { token });
  }

  /**
   * Send decline response for updating banking details
   * @param token
   */
  declineBankingDetails(token: string) {
    return this.http.post(this.getUrl(this.URL_APPROVAL_DECLINE, true), { token });
  }
}
